<template>
    <div>
        <ValidationObserver ref="formValidate">
            <b-row>
                <b-col cols="4">
                    <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="form.semester_id"
                                                 :setActive="true"
                                                 disabled
                                                 :validate-error="errors[0]"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <b-form-group :label="$t('course')" class="mb-1">
                        <ValidationProvider name="course_id" rules="required"
                                            v-slot="{ errors }">
                            <instructor-course-auto-complete v-model="form.course_id"
                                                             :semesterId="semesterId"
                                                             :validate-error="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('teaching_staff')">
                        <ValidationProvider name="instructor_id" rules="required" v-slot="{ errors }">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :returnType="'id'"
                                                 :valueObject="instructorValueObject"
                                                 :validate-error="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <ValidationProvider name="title" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('title')">
                            <b-form-input v-model="form.title"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>

                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="from_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('from_date')">
                            <b-form-input type="datetime-local" v-model="form.from_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="to_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('to_date')">
                            <b-form-input type="datetime-local" v-model="form.to_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="8">
                    <ValidationProvider name="file" :rules="form.file_name==null?'required':''" v-slot="{valid, errors}">
                        <b-form-group :label="$t('file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                             :placeholder="form.file_name"
                                             :drop-placeholder="$t('drop_file')"
                                             ref="fileInput"
                                             multiple
                                />
                                <b-button variant="outline-secondary"
                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="section_ids" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('section_id')">
                            <lined-textarea v-model="form.section_ids" :nowrap="false" :disabled="false"
                                            :styles="{ height: '124px' }" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="d-flex">
            <b-button class="mr-2" squared variant="primary" v-b-tooltip.hover :title="$t('show')"
                      @click="showFile()">
                <i class="ri-file-upload-line" style="font-size: 25px"></i>
            </b-button>
            <b-button variant="primary" @click="update">{{ $t('save').toUpper() }}</b-button>
        </div>
    </div>

</template>
<script>

import lmsContentService from "@/services/LmsContentService";
import moment from "moment";
import InstructorCourseAutoComplete from "@/components/interactive-fields/InstructorCourseAutoComplete.vue";
import LinedTextarea from "@/components/elements/LinedTextarea.vue";
import LmsHomeWorkEntryService from "@/services/LmsHomeWorkEntryService";

export default {
    components: {LinedTextarea, InstructorCourseAutoComplete},
    props: {
        semesterId: {},
        sectionId: {},
        formId: {
            type: Number
        }
    },
    data() {
        return {
            form: {
                course_id:null,
                from_date:null,
                to_date:null,
                title:null,
                instructor_id:null,
                file_name:null,
                section_ids:null,
                fileData:null,
            },
            parameter: {},
            instructorValueObject: {},
        }
    },
    watch: {
        formId(value) {
            this.getData(value)
        }
    },
    created() {
        this.getData(this.formId)
    },
    methods: {
        getData(id){
            lmsContentService.show(id)
                .then(response => {
                    let data =response.data.data
                    this.instructorValueObject = {
                        value: data.instructor_id,
                        text: data.instructor_name + ' - ' + data.instructor_surname
                    }
                    this.form ={
                        course_id:data.course_id,
                        from_date:data.from_date,
                        to_date:data.to_date,
                        title:data.title,
                        instructor_id:data.instructor_id,
                        section_ids:data.section_ids.join('\n'),
                        semester_id:data.semester_id,
                        file: null,
                        file_name: data.file ? data.file.file_name : null,
                        fileData: data.file ? data.file : null,
                    }

                }).catch(err => {
                this.showErrors(err)
            })
        },
        async update() {
            const isValid = await this.$refs.formValidate.validate();
            if (isValid) {
                let formData = new FormData()
                const dueDate = moment(this.form.due_date).format('YYYY-MM-DD HH:mm:ss')
                const fromDate = moment(this.form.from_date).format('YYYY-MM-DD HH:mm:ss')

                formData.append('semester_id', this.semesterId)
                formData.append('course_id', this.$route.params.courseId)
                formData.append('title', this.form.title)
                formData.append('instructor_id', this.form.instructor_id)
                formData.append('from_date', fromDate)
                formData.append('due_date', dueDate)

                if (this.form.file) {
                    formData.append('file', this.form.file[0])
                }

                if (this.form.section_ids) {
                    this.form.section_ids
                        .split('\n')
                        .filter(x => x.trim() !== '')
                        .map(x => parseInt(x.trim()))
                        .forEach(id => {
                            formData.append('section_ids[]', id)
                        })
                }
                lmsContentService.update(this.formId,formData)
                    .then(response => {
                        this.$toast.success(response.data.message)
                        this.$emit('updateContentSuccess', true)

                    }).catch(err => {
                    this.showErrors(err)
                })
            }

        },
        showFile(){
            if(this.form.fileData && this.form.fileData.uuid){
                lmsContentService.downloadFile(this.form.fileData.uuid)
                    .then(response=>{
                        this._downloadFile(response,this.form.fileData.file_name)
                    }).catch(err=>{
                    this.showErrors(err)
                })
            } else {
                this.$toast.error(this.$t('file_not_found'))
            }
        }
    },

};
</script>
